import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Component, ViewChild, Inject  } from '@angular/core';
// import { UsuarioComponent } from '../../usuario/usuario.component';
import { UsuarioService } from '../../../../providers/usuario.service';
import { EstadoPropuestaComponent } from '../../estado-propuesta/estado-propuesta.component';
import { EstadoPropuesta } from '../../../../interfaces/propuesta';
import { PropuestasService } from '../../../../providers/propuestas.service';
import { VerEstadosPropuestaComponent } from '../../ver-estados-propuesta/ver-estados-propuesta.component';

@Component({
    selector: 'crear-estado-propuesta-dialog',
    templateUrl: './crear-estado-propuesta-dialog.component.html',
    styleUrls: ['./crear-estado-propuesta-dialog.component.scss']
})
export class CrearEstadoPropuestaDialog {
    error: string = '';
    cargando: boolean = false;

    @ViewChild(EstadoPropuestaComponent) // accedemos al formulario de usuario
    @ViewChild(VerEstadosPropuestaComponent) // accedemos al lsitado, para obtener el workflow
    // private estadoForm: EstadoPropuestaComponent;
    @ViewChild(EstadoPropuestaComponent) estadoForm: EstadoPropuestaComponent;

    private flowPropuesta:VerEstadosPropuestaComponent;
    public estado_propuesta: EstadoPropuesta;
    public flujo:any;

    // referencia a si mismo para poder cerrar el dialog...etc.
    constructor(
        public dialogCrear: MatDialogRef<CrearEstadoPropuestaDialog>,
        private usurioService: UsuarioService,
        private propuestaService: PropuestasService,
        public snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    onUsuarioInput() { // si cambian los datos ingresados
        this.error = ''; // limpiamos los mensajes de error del formulario
    }

    onFormState(formState: any): void { // escucha los diferentes estados del formulario
        if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
            this.error = formState.mensaje;
        }

        if (typeof formState.cargando != undefined) {
            this.cargando = formState.cargando;
        }
    }

    onCancelar(): void {
        this.dialogCrear.close();
    }

    onCrear(): void {
        this.error = '';

        this.cargando = true;

        this.estado_propuesta = this.estadoForm.getEstado();

        // console.log(this.data.flujo.id, "flujo");

        this.propuestaService.crearEstadoPropuesta(this.estado_propuesta, this.data.flujo.id).subscribe(
            respuesta => {
                if (respuesta.estado == 1) {
                    this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
                    this.dialogCrear.close(respuesta);
                } else {
                    this.error = respuesta.mensaje;
                }
                this.cargando = false;

            },
            error => {
                this.cargando = false;
                this.error = error;
            }
        )

    }
}
